import { useState } from "react";
import { FileText, ChevronDown } from "lucide-react";

const fmt = (s) => { const d = new Date(s); return isNaN(d) ? (s || "") : d.toLocaleString("nl-NL", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }); };

// Structured view of every original form submission imported for a lead.
export function FormSubmissions({ lead }) {
  const subs = [...(lead?.form_submissions || [])].reverse();
  const [open, setOpen] = useState(0);
  if (!subs.length) return null;
  return (
    <div className="rounded-xl border border-[#E2E7EC] bg-[#F6F9FB] p-4 space-y-2" data-testid="form-submissions">
      <p className="text-xs uppercase tracking-wide text-[#5B6675] font-semibold flex items-center gap-1.5"><FileText className="h-3.5 w-3.5" /> Formulierinzendingen ({subs.length})</p>
      {subs.map((s, i) => (
        <div key={`${s.source_key}-${s.submission_id}`} className="rounded-lg bg-white border border-[#E2E7EC]" data-testid={`form-sub-${s.submission_id}`}>
          <button onClick={() => setOpen(open === i ? -1 : i)} className="w-full text-left px-3 py-2 flex items-center gap-2">
            <span className="text-sm font-medium text-[#16202B]">{s.form_name}</span>
            <span className="text-xs text-[#5B6675]">{fmt(s.submitted_at)}</span>
            <ChevronDown className={`h-4 w-4 ml-auto text-[#5B6675] transition-transform ${open === i ? "rotate-180" : ""}`} />
          </button>
          {open === i && (
            <dl className="px-3 pb-3 text-sm divide-y divide-[#EDF1F5]">
              {(s.answers || []).filter((a) => a.value).map((a, j) => (
                <div key={j} className="py-1.5 grid grid-cols-5 gap-2"><dt className="col-span-2 text-[#5B6675]">{a.label || a.key}</dt><dd className="col-span-3 text-[#16202B] whitespace-pre-wrap break-words">{a.value}</dd></div>
              ))}
              {s.utm && Object.keys(s.utm).length > 0 && (
                <details className="py-1.5" data-testid={`form-sub-tracking-${s.submission_id}`}>
                  <summary className="text-xs text-[#8994A3] cursor-pointer">Campagne- en trackinggegevens</summary>
                  <p className="mt-1 text-xs text-[#16202B] break-all">{Object.entries(s.utm).map(([k, v]) => `${k}=${v}`).join(" · ")}</p>
                </details>
              )}
              {s.consent && <div className="py-1.5 grid grid-cols-5 gap-2"><dt className="col-span-2 text-[#5B6675]">Toestemming</dt><dd className="col-span-3 text-[#16202B]">{s.consent}</dd></div>}
            </dl>
          )}
        </div>
      ))}
    </div>
  );
}
